import React from 'react';
import * as Styles from './SelectStyles';

interface Props {
  readonly name: string;
  readonly label: string;
  readonly placeHolder?: string;
  readonly errors?: string | undefined;
  children: React.ReactNode;
  disabled?: boolean;
  onChange: ((event: React.ChangeEvent<HTMLSelectElement>) => void) | undefined;
}

const Select: React.FC<Props> = ({ name, label, placeHolder, errors, disabled, onChange, children }: Props) => {
  return (
    <Styles.Container>
      <Styles.Label htmlFor={name}>{label}</Styles.Label>
      <Styles.Icon name="pointer-down" />
      <Styles.Select required onChange={onChange} disabled={disabled} id={name} name={name} placeholder={placeHolder}>
        {children}
      </Styles.Select>
      {errors && <Styles.Error>{errors}</Styles.Error>}
    </Styles.Container>
  );
};
Select.defaultProps = {
  disabled: false,
};

export default Select;
